<template>
  <div v-if="discounts?.length">
    <div :class="noBorder ? '' : 'border-b'"></div>
    <div :class="noPadding ? '' : 'px-5 md:px-8 pt-2 md:pb-8 sm:pb-8'">
      <h5 v-if="summaryHeading" :class="noPadding ? '' : 'pt-5'" class="text-lg-bold title pb-2 text-racq-dark-grey">
        {{ summaryHeading }}
      </h5>
      <TagList :tags="discounts" :tagType="TagTypes.discount" :tagSize="tagSize"></TagList>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { TagSize, TagTypes } from '@/enums/tag-enums';
import TagList from '@/components/TagList/TagList.vue';

const { getLocaleMessage } = useI18n();
const dictionary: Record<string, string> = getLocaleMessage('en') as any;

const props = defineProps<{
  summaryHeading?: string;
  showOnlineDiscount?: boolean;
  showOnlineDiscountLast?: boolean;
  noBorder?: boolean;
  noPadding?: boolean;
  discounts: string[];
  tagSize: TagSize;
}>();

const discounts = computed(() => {
  let discounts = [] as string[];
  props.discounts.forEach((value: string) => {
    discounts.push(dictionary[value]);
  });
  return discounts;
});
</script>
